import Listing from "../Listing";
import React, { useEffect } from "react";
import Header from "../../../layout/Header";
import Footer from "../../../layout/Footer";
import Loader from "../../../components/other/Loader";
import HeroSection from "../../../layout/HeroSection";
import { useDispatch, useSelector } from "react-redux";
import { pageRoutes } from "../../../routes/pageRoutes";
import { fetchlessonelectricalEngineer } from "../../../redux/action/lessonsAction";
import SecureContent from "../../../components/secureContent";

const ElectricalEngineering = () => {
  const dispatch = useDispatch();
  const { electricalEngineeringList, isLoading } = useSelector(
    (state) => state?.lessonsReducer
  );
 
  useEffect(() => {
    dispatch(fetchlessonelectricalEngineer());
  }, []);


  if (isLoading) {
    return <Loader />;
  }
  return (
    <div>
      <SecureContent/>
      <Header />
      <HeroSection
        label={
          <h1 className="mb-1">{"Electrical engineering and robot combat"}</h1>
        }
        breadcrumbItems={[
          { name: "Home", path: `${pageRoutes?.home}/` },
          {
            name: "Electrical engineering and robot combat",
            path: `${pageRoutes?.home}/`,
          },
        ]}
      />

      <Listing contentData={electricalEngineeringList} color={"#36296c"} />
      <Footer />
    </div>
  );
};

export default ElectricalEngineering;
